module.exports = __webpack_public_path__ + "static/media/4.Chaff Cutter.51d04f8c.jpg";